import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { BsPaperclip, BsChevronDown, BsChevronUp } from 'react-icons/bs';
import styles from './Conversations.module.css';

const ConversationAttachments = ({ attachments }) => {
  const [showAttachments, setShowAttachments] = useState(false);

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewSrc, setPreviewSrc] = useState('');
  const [previewAlt, setPreviewAlt] = useState('');

  const openPreview = (src, alt) => {
    setPreviewSrc(src);
    setPreviewAlt(alt);
    setPreviewOpen(true);
  };

  return (
    attachments.length > 0 && (
      <>
        <Button
          variant="link"
          className={styles.attachmentsLink}
          onClick={() => setShowAttachments(!showAttachments)}
        >
          <BsPaperclip />
          {attachments.length} Attachment{attachments.length > 1 ? 's' : ''}{' '}
          {showAttachments ? <BsChevronUp /> : <BsChevronDown />}
        </Button>

        {showAttachments && (
          <div className={styles.attachments}>
            {attachments.map((attachment) => {
              const isImage = attachment.mime_type?.includes('image/');

              if (isImage) {
                return (
                  <button
                    type="button"
                    key={attachment.id}
                    className={styles.attachment}
                    title={attachment.name}
                    onClick={() => openPreview(attachment.public_url, attachment.name)}
                    style={{ border: 0, background: 'transparent', padding: 0 }}
                  >
                    <img
                      src={attachment.public_url}
                      alt={attachment.name}
                      style={{ maxWidth: 100, maxHeight: 100 }}
                    />
                  </button>
                );
              }

              // non-image: keep link (download/open)
              return (
                <a
                  className={styles.attachment}
                  key={attachment.id}
                  title={attachment.name}
                  href={attachment.public_url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className={styles.file}>
                    {attachment.name}
                    <span>{attachment.size}</span>
                  </div>
                </a>
              );
            })}
          </div>
        )}

        <Modal
          show={previewOpen}
          onHide={() => setPreviewOpen(false)}
          centered
          size="xl"
        >
          <Modal.Body style={{ padding: 0 }}>
            <img
              src={previewSrc}
              alt={previewAlt}
              style={{ width: '100%', height: 'auto', display: 'block' }}
            />
          </Modal.Body>
        </Modal>
      </>
    )
  );
};

export default ConversationAttachments;
